/* eslint-disable react/prop-types */
import React, { createContext, useContext, useReducer, useState } from 'react';
import PropTypes from 'prop-types';

import { getDocumentType } from 'utils/documentDictionary';
import MHDRequests from 'services/MHDRequests';
import { useEHRContext } from 'contexts/EHRContext';
import { flatten, verifyEmptyTag, isBase64 } from 'utils/AuxiliarFunctions';
import { useNewConsentModalContext } from 'pages/SharePage/Context/NewConsentModalContext';
import { formatDateDisplay, getISODateLocalTime } from 'utils/dateFunctions';
import striptags from 'striptags';
import {
  // DocumentError,
  ReportModal,
  ArchetypeMenu,
} from './components';

import './ReportModalContext.css';

const ReportModalContext = createContext({
  selectReport: () => {},
  ReportModal: () => <></>,
});

function reportModalReducer(prevState, action) {
  switch (action.type) {
    case 'SET_REPORT':
      return {
        ...prevState,
        title: action.content.title,
        report: action.content.report,
        show: true,
        practitioner: action.content.practitioner,
        isoDate: action.content.isoDate,
        organization: action.content.organization,
      };
    case 'SET_SHOW':
      return { ...prevState, show: action.content };

    case 'RESET':
      return { title: '', report: '', show: false };

    default:
      throw new Error('Action type not available in Reducer');
  }
}

export function ReportModalContextProvider({ children }) {
  const [reportModalState, reportModalDispatch] = useReducer(
    reportModalReducer,
    {
      title: '',
      report: '',
      show: false,
    },
  );
  const { organizationList } = useNewConsentModalContext();
  const [archetypeSelected, setArchetypeSelected] = useState(false);
  const [item, setItem] = useState('');
  const { ehrState } = useEHRContext();
  const codeString = {};
  const [findOrganization, setFindOrganization] = useState('Não encontrado');
  const [auxPractitioner, setAuxPractitioner] = useState('');

  function resetComponent() {
    setArchetypeSelected(false);
    setItem('');
    setAuxPractitioner('');
    setFindOrganization('Não encontrado');
    reportModalDispatch({ type: 'RESET' });
  }

  const mockedOrganizations = {
    resourceType: 'Bundle',
    id: '146ecb21-e2b8-453a-a8ac-b3673bcbc974',
    meta: {
      lastUpdated: '2022-11-07T15:36:36.061-03:00',
    },
    type: 'searchset',
    total: 41,
    link: [
      {
        relation: 'self',
        url: 'http://localhost:8081/hapi/fhir/Organization?_count=99&_elements=identifier%2Cname%2Calias',
      },
    ],
    entry: [
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2006197',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2006197',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2006197',
            },
          ],
          name: 'Hospital Universitário Professor Alberto Antunes da Universidade Federal de Alagoas',
          alias: ['HUPAA-Ufal'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2017644',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2017644',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2017644',
            },
          ],
          name: 'Hospital Universitário Getúlio Vargas da Universidade Federal do Amazonas',
          alias: ['HUGV-Ufam'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0003816',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0003816',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0003816',
            },
          ],
          name: 'Hospital Universitário Professor Edgard Santos da Universidade Federal da Bahia',
          alias: ['Hupes-UFBA'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0004731',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0004731',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0004731',
            },
          ],
          name: 'Maternidade Climério de Oliveira da Universidade Federal da Bahia',
          alias: ['MCO-UFBA'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2481286',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2481286',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2481286',
            },
          ],
          name: 'Maternidade Escola Assis Chateaubriand da Universidade Federal do Ceará',
          alias: ['Meac-UFC'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2561492',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2561492',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2561492',
            },
          ],
          name: 'Hospital Universitário Walter Cantídio da Universidade Federal do Ceará',
          alias: ['HUWC-UFC'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0010510',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0010510',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0010510',
            },
          ],
          name: 'Hospital Universitário de Brasília da Universidade de Brasília',
          alias: ['HUB-UnB'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-4044916',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-4044916',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '4044916',
            },
          ],
          name: 'Hospital Universitário Cassiano Antonio Moraes da Universidade Federal do Espírito Santo',
          alias: ['Hucam-Ufes'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2338424',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2338424',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2338424',
            },
          ],
          name: 'Hospital das Clínicas da Universidade Federal de Goiás',
          alias: ['HC-UFG'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2726653',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2726653',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2726653',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal do Maranhão',
          alias: ['HU-UFMA'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0027049',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0027049',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0027049',
            },
          ],
          name: 'Hospital das Clínicas da Universidade Federal de Minas Gerais',
          alias: ['HC-UFMG'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2218798',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2218798',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2218798',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal de Juiz de Fora',
          alias: ['HU-UFJF'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2206595',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2206595',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2206595',
            },
          ],
          name: 'Hospital de Clínicas da Universidade Federal do Triângulo Mineiro',
          alias: ['HC-UFTM'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2146355',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2146355',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2146355',
            },
          ],
          name: 'Hospital de Clinicas de Uberlândia',
          alias: ['HC-UFU'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0009709',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0009709',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0009709',
            },
          ],
          name: 'Hospital Universitário Maria Aparecida Pedrossian da Universidade Federal de Mato Grosso do Sul',
          alias: ['Humap-UFMS'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2710935',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2710935',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2710935',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal da Grande Dourados',
          alias: ['HU-UFGD'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2655411',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2655411',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2655411',
            },
          ],
          name: 'Hospital Universitário Júlio Müller da Universidade Federal do Mato Grosso',
          alias: ['HUJM-UFMT'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2332981',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2332981',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2332981',
            },
          ],
          name: 'Complexo Hospitalar Universitário João de Barros Barreto da Universidade Federal do Pará',
          alias: ['CHUJBB-UFPA '],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2694751',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2694751',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2694751',
            },
          ],
          name: 'Complexo Hospitalar Universitário Bettina Ferro de Souza da Universidade Federal do Pará',
          alias: ['HUBFS-UFPA'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2504502',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2504502',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2504502',
            },
          ],
          name: 'Hospital Universitário Júlio Bandeira da Universidade Federal de Campina Grande',
          alias: ['HUJB-UFCG'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2676060',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2676060',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2676060',
            },
          ],
          name: 'Hospital Universitário Alcides Carneiro da Universidade Federal de Campina Grande',
          alias: ['HUAC - UFCG'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2400243',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2400243',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2400243',
            },
          ],
          name: 'Hospital Universitário Lauro Wanderley da Universidade Federal da Paraíba',
          alias: ['HULW-UFPB'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-6042414',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-6042414',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '6042414',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal do Vale do São Francisco',
          alias: ['HU-Univasf'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0000396',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0000396',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0000396',
            },
          ],
          name: 'Hospital das Clínicas da Universidade Federal de Pernambuco',
          alias: ['HC-UFPE'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-3285391',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-3285391',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '3285391',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal do Piauí',
          alias: ['HU-UFPI'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2384299',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2384299',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2384299',
            },
          ],
          name: 'Complexo do Hospital de Clínicas da Universidade Federal do Paraná ',
          alias: ['CHC-UFPR '],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2640244',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2640244',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2640244',
            },
          ],
          name: 'Maternidade Victor Ferreira do Amaral da Universidade Federal do Paraná ',
          alias: ['MVFA-UFPR'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0012505',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0012505',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0012505',
            },
          ],
          name: 'Hospital Universitário Antônio Pedro da Universidade Federal Fluminense',
          alias: ['Huap-UFF'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2295415',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2295415',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2295415',
            },
          ],
          name: 'Hospital Universitário Gaffrée e Guinle da Universidade Federal do Estado do Rio de Janeiro',
          alias: ['HUGG-Unirio'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2409208',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2409208',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2409208',
            },
          ],
          name: 'Maternidade Escola Januário Cicco da  Universidade Federal do Rio Grande do Norte',
          alias: ['Mejc-UFRN'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2653982',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2653982',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2653982',
            },
          ],
          name: 'Hospital Universitário Onofre Lopes da Universidade Federal do Rio Grande do Norte',
          alias: ['Huol-UFRN'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-4014111',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-4014111',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '4014111',
            },
          ],
          name: 'Hospital Universitário Ana Bezerra da Universidade Federal do Rio Grande do Norte',
          alias: ['Huab-UFRN'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2252694',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2252694',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2252694',
            },
          ],
          name: 'Hospital Escola da Universidade Federal de Pelotas',
          alias: ['HE-UFPel'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2707675',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2707675',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2707675',
            },
          ],
          name: 'Hospital Universitário Doutor Miguel Riet Corrêa Junior da Fundação Universidade Federal do Rio Grande',
          alias: ['HU-Furg'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2244306',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2244306',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2244306',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal de Santa Maria',
          alias: ['HUSM-UFSM'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-3157245',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-3157245',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '3157245',
            },
          ],
          name: 'Hospital Universitário da Universidade de Santa Catarina',
          alias: ['HU-UFSC'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0002534',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0002534',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0002534',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal de Sergipe',
          alias: ['HU-UFS'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-6568343',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-6568343',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '6568343',
            },
          ],
          name: 'Hospital Universitário de Lagarto da Universidade Federal de Sergipe',
          alias: ['HUL-UFS'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-5586348',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-5586348',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '5586348',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal de São Carlos',
          alias: ['HU-UFScar'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-3654826',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-3654826',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '3654826',
            },
          ],
          name: 'Hospital de Doenças Tropicais da Universidade Federal de Tocantins',
          alias: ['HDT-UFT'],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl:
          'http://localhost:8081/hapi/fhir/Organization/2.16.76.1.3.3-15126437000143',
        resource: {
          resourceType: 'Organization',
          id: '2.16.76.1.3.3-15126437000143',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T12:00:17.915-03:00',
            source: '#JW6VUGU7eRGEcAnD',
            tag: [
              {
                system:
                  'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.76.1.3.3',
              value: '15126437000143',
            },
          ],
          name: 'Hospitais Universitários Federais',
          alias: ['EBSERH'],
        },
        search: {
          mode: 'match',
        },
      },
    ],
  };
  async function getOrganization(id) {
    try {
      const findOrg = organizationList?.find(
        (org) =>
          org.resource?.identifier[0]?.value === id ||
          org.resource?.alias[0] === id ||
          org.resource?.name === id,
      )?.resource.alias[0];
      if (findOrg) setFindOrganization(findOrg);
      else {
        const findMockedOrg = mockedOrganizations.entry?.find(
          (org) =>
            org.resource?.identifier[0]?.value === id ||
            org.resource?.alias[0] === id ||
            org.resource?.name === id,
        )?.resource.alias[0];
        if (findMockedOrg) setFindOrganization(findMockedOrg);
        else setFindOrganization(id);
      }
      return;
    } catch (err) {
      const findMockedOrg = mockedOrganizations.entry?.find(
        (org) =>
          org.resource?.identifier[0]?.value === id ||
          org.resource?.alias[0] === id ||
          org.resource?.name === id,
      )?.resource.alias[0];
      setFindOrganization(findMockedOrg);
      console.log(err);
    }
  }
  function HandleDataFieldIsObject({ value, timeToShow, label }) {
    if (value.terminology_name === 'local') {
      return (
        <div className="reportModal-contentField">
          {label !== '' && (
            <p className="fieldKey-text">{`${striptags(label)}`}</p>
          )}

          {value.value !== '' && (
            <p className="fieldValue-text">{timeToShow}</p>
          )}
        </div>
      );
    }

    return (
      <div className="reportModal-contentField">
        {label !== '' && (
          <p className="fieldKey-text">{`${striptags(label)}`}</p>
        )}

        <p className="fieldValue-text">
          {`${striptags(value.defining_code)} - ${striptags(value.value)}`}
        </p>
      </div>
    );
  }

  function HandleDataFieldSimple({ timeToShow, label }) {
    if (label === 'Estabelecimento de saúde') {
      getOrganization(timeToShow);
      return (
        <div className="reportModal-contentField">
          {label !== '' && <p className="fieldKey-text">{striptags(label)}</p>}
          <p className="fieldValue-text">
            {reportModalState.organization?.toUpperCase() ||
              findOrganization?.toUpperCase()}
          </p>
        </div>
      );
    }
    if (label === 'Nome do profissional') {
      setAuxPractitioner(timeToShow);
      return (
        <div className="reportModal-contentField">
          {label !== '' && <p className="fieldKey-text">{striptags(label)}</p>}
          <p className="fieldValue-text">{timeToShow}</p>
        </div>
      );
    }
    return (
      <div className="reportModal-contentField">
        {label !== '' && <p className="fieldKey-text">{striptags(label)}</p>}

        {timeToShow.split('\n').map((line, i) => (
          <>
            <p className="fieldValue-text" key={i}>
              {line === 'true' || line === 'false' ? (
                <>{line === 'true' ? 'Sim' : 'Não'}</>
              ) : (
                `${line}`
              )}
              <br />
            </p>
          </>
        ))}
        {/* <p className="fieldValue-text">{`${timeToShow.replace(/n/, <br />)}`}</p> */}
      </div>
    );
  }

  function selectArchetype(archetype) {
    setItem(archetype);
    setArchetypeSelected(true);
  }

  async function selectReport({
    idArg,
    documento_clinico,
    practitioner,
    isoDate,
    organization,
  }) {
    let binaryId = idArg;
    if (binaryId) {
      binaryId = binaryId.split('oid:');
      binaryId = binaryId[1] || binaryId[0];
    }
    // eslint-disable-next-line no-param-reassign
    if (binaryId) {
      setArchetypeSelected(false);
      let returned_report = null;
      returned_report = await MHDRequests.getReport({
        binaryId,
        organizationId: ehrState.subject.organizationId,
        subjectToken: ehrState.subject.token,
        subjectId: ehrState.subject.id,
        subjectRole: '',
        purposeOfUse: ehrState.resource.purposeOfUse,
      });

      if (returned_report === 'network_error' || !returned_report)
        returned_report = {};
      else if (documento_clinico) {
        let docKey = Object.keys(returned_report);
        if (Array.isArray(docKey) && docKey.length) {
          docKey = docKey[0];
          // const docName = displayFullNameDoc(documento_clinico.split('.')[0]);
          const docName = getDocumentType({
            docCode: documento_clinico.split('.')[0],
          }).name;
          if (docKey === 'pdf') {
            Object.defineProperty(
              returned_report,
              docName,
              Object.getOwnPropertyDescriptor(returned_report, docKey),
            );
            delete returned_report[docKey];
          }
        }
      }
      reportModalDispatch({
        type: 'SET_REPORT',
        content: {
          title: Object.keys(returned_report)[0],
          report: returned_report,
          practitioner,
          isoDate,
          organization,
        },
      });
    }
  }

  function createDataField(valueArg, labelArg) {
    // Função responsável por criar o nome de um campo e seu valor correspondente
    // Renderiza o campo mais interno do JSON, com estrutura {label: value}
    let value = valueArg;

    if (value === undefined) return <div />;

    const label = labelArg.split('__')[labelArg.split('__').length - 1];

    // Substituição dos códigos locais dos arquétipos
    if (value in codeString) value = codeString[value];
    if (label in codeString) {
      if (typeof codeString[label] === 'string') value = codeString[label];
      else if (value in codeString[label]) value = codeString[label][value];
    }
    const isObject = typeof value === 'object';
    const hasHour = label.includes('Hora') || label.includes('Data e hora');

    let timeToShow = '';
    if (isObject) {
      if (hasHour) {
        timeToShow = getISODateLocalTime(value?.value);
        timeToShow = new Date(timeToShow).toLocaleString('pt-BR');
      } else timeToShow = formatDateDisplay(striptags(value.value));
    } else if (value) {
      if (hasHour) {
        timeToShow = getISODateLocalTime(value);
        timeToShow = new Date(timeToShow).toLocaleString('pt-BR');
      } else timeToShow = formatDateDisplay(striptags(value));
    }
    if (isObject) {
      return (
        <HandleDataFieldIsObject
          value={value}
          timeToShow={timeToShow}
          label={label}
        />
      );
    }

    // Letras minúsculas no value para manter um padrão
    value = value.toLowerCase();
    value = value[0].toUpperCase() + value.slice(1);

    if (value === 'True') value = 'Sim';
    else if (value === 'False') value = 'Não';
    return <HandleDataFieldSimple timeToShow={timeToShow} label={label} />;
  }

  function docContentData(obj, key) {
    // Função que renderiza o array contendo um conjunto de "data_fields",
    // que é o nível de informação mais interno da renderização
    if (key) {
      const temp = obj;
      obj = {};
      obj[key] = temp;
    }
    const temp = flatten(obj);
    // eslint-disable-next-line no-param-reassign
    obj = Object.keys(temp);
    // Cria um array contendo os values em pares, a fim de renderizar duas colunas
    const new_temp = [];
    for (let i = 0; i < obj.length; i += 2) new_temp.push([obj[i], obj[i + 1]]);

    return (
      <>
        {new_temp.map((auxItem) => {
          // Verifica se o objeto em questão só possui
          // value (label já renderizado em create_level_X)
          for (let i = 0; i < auxItem.length; i += 1) {
            let obj_is_empty = true;
            for (const auxKey in temp[auxItem[i]])
              if (auxKey) obj_is_empty = false;

            // Se o título do campo já foi renderizado, chama o createDataField com label vazio
            // Ou seja, renderiza somente o value
            if (obj_is_empty && auxItem[i] !== undefined)
              temp[auxItem[i]] = 'Não informado';
          }
          // Caso contrário, renderiza duas colunas contendo {label: value}
          return (
            <>
              {auxItem[0] !== undefined &&
                createDataField(temp[auxItem[0]], auxItem[0])}
              {auxItem[1] !== undefined
                ? createDataField(temp[auxItem[1]], auxItem[1])
                : null}
            </>
          );
        })}
      </>
    );
  }

  function createReportContent(obj) {
    if (!obj) return null;
    // Função responsável por renderizar o título de uma seção
    // dentro do arquétipo
    let reportContentCreated = false;
    let create_Col = true;
    let first_Col = [];
    const condOneItem =
      typeof obj[Object.keys(obj)[0]] === 'string' &&
      Object.keys(obj).length === 1;
    let oneItemJson = {};
    if (condOneItem) {
      oneItemJson = obj;
      const key = Object.keys(oneItemJson)[0];
      return <>{createDataField(oneItemJson[key], key)}</>;
    }

    return (
      <>
        {Object.keys(obj).map((auxItem) => {
          const tempJson = {};
          let verifyEmpty = [];
          let key = '';
          if (typeof obj[auxItem] === 'string') {
            tempJson[auxItem] = obj[auxItem];
            key = auxItem;
          } else {
            verifyEmpty = verifyEmptyTag(obj[auxItem]);
            if (Array.isArray(verifyEmpty)) {
              tempJson[auxItem] = verifyEmpty[0];
              key = verifyEmpty[1];
            } else {
              tempJson[auxItem] = obj[auxItem];
              key = auxItem;
            }
          }
          if (reportContentCreated) create_Col = true;

          // Verifica se o objeto em questão já é um
          // data field -> estrutura {label: value}
          // Nesse caso, ao inves de renderizar o
          // título, chama diretamente
          // a função que renderiza os campos de
          // informação (em duas colunas)
          const condDataField =
            (typeof tempJson[key] === 'string' &&
              Object.keys(tempJson).length === 1) ||
            'terminology_name' in tempJson;

          if (condDataField) {
            reportContentCreated = false;
            create_Col = !create_Col;
            if (create_Col) return <>{createDataField(tempJson[key], key)}</>;

            first_Col = [tempJson[key], key];

            return <div />;
          }

          first_Col = [tempJson[auxItem], key];

          reportContentCreated = true;
          return (
            <>
              {!create_Col && createDataField(first_Col[0], first_Col[1])}
              {Object.keys(tempJson).map((auxItem2) => (
                <>
                  {/* Renderiza o subtítulo */}
                  {/* {DocContentTitle(auxItem2)} */}

                  {/* Renderiza o array com os dados */}
                  {docContentData(tempJson[auxItem2], key)}
                </>
              ))}
            </>
          );
        })}
      </>
    );
  }

  function createReportMenu(objArg) {
    // Função que renderiza o menu com arquétipos para navegação
    // dentro de um RES
    // eslint-disable-next-line no-param-reassign
    let obj = objArg;
    if (objArg === undefined || objArg === null) {
      return (
        <div>
          Houve um erro ao tentar renderizar o documento, tente recarregar a
          página
        </div>
      );
    }

    if (typeof objArg === 'string' && isBase64(objArg)) {
      return (
        <div>
          <embed
            src={`data:application/pdf;base64,${objArg}`}
            type="application/pdf"
            width="100%"
            height="450rem"
          />
        </div>
      );
    }
    if (Object.keys(obj).length === 1) obj = obj[Object.keys(obj)[0]];

    const keys = Object.keys(obj);

    const keyGroup = [];
    for (let i = 0; i < keys.length; i += 4)
      keyGroup.push(keys.slice(i, i + 4));

    while (keyGroup[keyGroup.length - 1].length !== 4)
      keyGroup[keyGroup.length - 1].push('');

    let auxItem = item;

    if (!archetypeSelected) {
      setArchetypeSelected(true);
      auxItem = keys[0];
      setItem(keys[0]);
    }

    const tempJson = {};
    if (typeof obj[auxItem] === 'string') tempJson[auxItem] = obj[auxItem];
    else tempJson[auxItem] = verifyEmptyTag(obj[auxItem]);
    const key = auxItem;

    const condDataField =
      (typeof tempJson[key] === 'string' &&
        Object.keys(tempJson).length === 1) ||
      'terminology_name' in tempJson;

    const title = obj[auxItem];

    return (
      <>
        {ArchetypeMenu(keyGroup, selectArchetype, auxItem)}
        <div className="reportModal-dataFields-container">
          {condDataField
            ? createDataField(tempJson[key], auxItem)
            : createReportContent(title)}
        </div>
      </>
    );
  }

  const contextValue = {
    selectReport,
  };

  return (
    <ReportModalContext.Provider value={contextValue}>
      <ReportModal
        show={reportModalState.show}
        dismountModal={resetComponent}
        title={reportModalState.title}
        contextText={null}
        organization={reportModalState.organization}
        findOrganization={findOrganization}
        isoDate={reportModalState.isoDate}
        auxPractitioner={auxPractitioner}
        practitioner={reportModalState.practitioner}
        body={
          <>
            {/* {typeof reportModalState.report === 'string' && <DocumentError />} */}
            {reportModalState.report &&
              createReportMenu(
                reportModalState.report[
                  Object.keys(reportModalState.report)[0]
                ],
              )}
          </>
        }
      />
      {children}
    </ReportModalContext.Provider>
  );
}

export function useReportModalContext() {
  return useContext(ReportModalContext);
}

ReportModalContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
